export const SET_GUEST_NOTICE_VISIBLE = 'Guest/GuestNotice/visible';
